import { APP_ROUTES } from '@routes/app-routes.constants';
import { createRoleGuard } from './role.guard';

export const teamTrackingGuard = createRoleGuard((auth) => auth.isTeamTrackingManager$, {
  denyPath: APP_ROUTES.accessDenied,
  timeoutPath: APP_ROUTES.home,
});
